<div class="agpr-emailHeader">
    <div class="agpr-emailHeader-subject">
        <label *ngIf="subjectLine">
            {{ subjectLine }}
        </label>
    </div>
    <div>
        <label *ngIf="previewText">
            {{ previewText }}
        </label>
    </div>
    <div class= "agpr-emailHeader-grid">
        <label class="agpr-emailHeader-bold">{{'Discover.targeting.distribution.header.fromName' | localize}}</label>
        <label *ngIf="fromName">
            {{ fromName }}
        </label>

        <label class="agpr-emailHeader-bold">{{'Discover.targeting.distribution.header.replyEmail' | localize}}</label>
        <label *ngIf="replyEmail">
            {{ replyEmail }}
        </label>
        <label class="agpr-emailHeader-bold">
            {{'Discover.targeting.distribution.header.sentDate' | localize }}
        </label>
        <label>
            {{ sentDate }}
        </label>
    </div>
</div>
